export const handleDate = (e, name, setData) => {
    setData((prevState) => ({
      ...prevState,
      [name]: e,
    }));
  };
  
  export const handleData = (e, name, setData) => {
    
    setData((prevState) => ({
      ...prevState,
      [name]: e,
    }));
  };
  
  export const handleSelect = (e, name, setData) => {
    setData((prevState) => ({
      ...prevState,
      [name]: e,
    }));
  };
  
  export const handleCheck = (e, name, setData) => {
    
    setData((prevState) => ({
      ...prevState,
      [name]: e,
    }));
  };